import { useSelector } from 'react-redux';
import { reversedPhoneNumberFormatter } from '../functions/phoneNumberFormatter';
import { selectInputs } from '../redux/inputsReducer';
import { selectAppConfig } from '../redux/appConfigReducer';

const useInputsValidator = () => {
  const {
    firstName,
    lastName,
    email,
    zipCode,
    phoneNumber,
    preferredContactMethod,
    ccpa,
    topicOfInterest,
    tradeInVehicleMake,
    tradeInVehicleModel,
    tradeInVehicleYear,
    tradeInVehicleMileage,
    tradeInVehicleTrimLine,
    tradeInVehicleVin,
    modelFamilyOfInterest,
    universalConsent,
  } = useSelector(selectInputs);

  const { presetForm, market, vehicleId } = useSelector(selectAppConfig);

  const isUSMarket = market?.toLowerCase().includes('us');

  const isCaliforniaZip = Number(zipCode) >= 90001 && Number(zipCode) <= 96162;

  const isPhoneNumberValid =
    preferredContactMethod === 'email' || reversedPhoneNumberFormatter(phoneNumber).length === 10;

  const isEmailValid =
    email.trim() !== '' && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email);

  const isUSZipCodeValid = zipCode.trim() !== '' && /^[0-9]{5}(-[0-9]{4})?$/i.test(zipCode);

  const isCAPostalCodeValid =
    zipCode.trim() !== '' && /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/i.test(zipCode);

  const isCcpaValid = isCaliforniaZip ? ccpa : true;

  const isTradeInForm = presetForm === 'tradeIn';

  const isTradeInVehicleValid = () => {
    const isYearValid = /^\d{4}$/.test(tradeInVehicleYear.trim());
    const isMileageValid = /^\d+$/.test(tradeInVehicleMileage.trim());
    const isVinValid = tradeInVehicleVin.trim() === '' || tradeInVehicleVin.trim().length === 17;
    const isModelFamilyValid = vehicleId ? true : !!modelFamilyOfInterest;

    return (
      tradeInVehicleModel.trim() !== '' &&
      isYearValid &&
      isMileageValid &&
      tradeInVehicleTrimLine.trim() !== '' &&
      isVinValid &&
      tradeInVehicleMake.trim() !== '' &&
      isModelFamilyValid
    );
  };

  const isValidForm = () => {
    const isValid =
      firstName.trim() !== '' &&
      lastName.trim() !== '' &&
      isEmailValid &&
      (isUSMarket ? isUSZipCodeValid : isCAPostalCodeValid) &&
      isPhoneNumberValid &&
      isCcpaValid &&
      (!!presetForm || (!presetForm && topicOfInterest)) &&
      (!isTradeInForm || isTradeInVehicleValid());

    if (!process.env.IS_LEGACY) {
      return isValid && universalConsent;
    }

    return isValid;
  };

  return isValidForm;
};

export default useInputsValidator;
